import {
  Dialog,
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { ErrorSuccessDialogContent } from "../../modules/projects/components/ErrorSuccessDialogContent";

interface UnexpectedErrorDialogProps {
  message: string;
  onClickDone: VoidFunction;
}

export const UnexpectedErrorDialog: React.FC<UnexpectedErrorDialogProps> = ({
  message,
  onClickDone,
}) => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const tokens = useFoundationColorTokens();
  const typography = useTypography();

  return (
    <Dialog
      open
      title={t("common.unexpectedError")}
      secondaryButtonText={t("common.done")}
      onSecondaryButtonClick={onClickDone}
    >
      <ErrorSuccessDialogContent
        spacing={spacing}
        tokens={tokens}
        typography={typography}
        isError={true}
        errorSuccessText={message}
      />
    </Dialog>
  );
};
